import Page from '@customer/templates/page/Page';
import styles from './MapPage.module.scss';
import { useTranslation } from 'react-i18next';
import MapView from '@customer/components/maps/map-view/MapView';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import { setView } from '@customer/store/slices/mapSlice';
import { useMap, useMapEvent } from 'react-leaflet';
import { useMapLastPositionData } from '@customer/components/maps/hooks/useLastMapPositionData';
import LiveAssetsLayer from '@customer/components/maps/live-assets/LiveAssetsLayer';
import AllGeofencesLayer from '@customer/components/maps/all-geofences-layer/AllGeofencesLayer';

const PersistedLocation = () => {
  const map = useMap();

  const dispatch = useAppDispatch();
  const userData = useAppSelector(state => state.auth);

  const update = () => {
    const centre = map.getCenter().wrap();

    dispatch(
      setView({
        siteId: userData.siteId ?? '',
        centreLat: centre.lat,
        centreLon: centre.lng,
        zoom: map.getZoom(),
      }),
    );
  };

  useMapEvent('zoomend', () => update());
  useMapEvent('dragend', () => update());

  return null;
};

export function MapPage() {
  const { t } = useTranslation();
  const { centre, zoom } = useMapLastPositionData();

  return (
    <Page
      header={
        <div className={styles.header}>
          <span>{t('Map')}</span>
        </div>
      }
      nav={[]}
    >
      <div className={styles.map}>
        <MapView initialCentre={centre} initialZoom={zoom} showLayersControl={true}>
          <PersistedLocation />
          <AllGeofencesLayer />
          <LiveAssetsLayer />
        </MapView>
      </div>
    </Page>
  );
}

export default MapPage;
